// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-home-page-join-deadline {
  font-size: 24px !important;
  font-weight: 700 !important;
  border-bottom: 2px solid #002129;
  color: #002129;
  background-color: #FFC60A;
  padding: 16px 0;
}
@media (max-width: 900px) {
  .game-home-page-join-deadline {
    font-size: 16px !important;
  }
}

.game-home-page-logo-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  margin-bottom: 32px;
  margin-top: 32px;
}
.game-home-page-logo-box.does-user-belong-game-over {
  margin-bottom: 0px;
}

.game-home-page-logo {
  height: 160px;
  object-fit: contain;
}

.game-home-page-button-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: 32px;
}
@media (max-width: 900px) {
  .game-home-page-button-group {
    flex-direction: column;
    gap: 0;
    margin-top: 16px;
  }
}

.game-home-page-button {
  font-size: 14px;
  font-weight: 700;
  width: 182px;
  height: 36px;
  white-space: nowrap;
  cursor: pointer;
}
.game-home-page-button.my-picks-button {
  margin-bottom: 0;
}
@media (max-width: 900px) {
  .game-home-page-button.my-picks-button {
    margin-bottom: 8px;
  }
}

.game-home-page-title {
  color: #002129;
  text-align: center;
  font-size: 24px !important;
  font-weight: 700 !important;
  text-decoration: underline !important;
  margin-top: 32px !important;
  margin-bottom: 8px !important;
}
@media (max-width: 900px) {
  .game-home-page-title {
    font-size: 16px !important;
  }
}

.game-home-page-subtitle {
  color: #002129;
  text-align: center;
  font-size: 16px !important;
  font-weight: 600 !important;
  margin-bottom: 16px !important;
}

.game-home-page-action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  margin-top: 32px;
}
@media (max-width: 900px) {
  .game-home-page-action-buttons {
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
  }
}

.game-home-page-screen-capture-container {
  text-align: center;
}

.game-home-page-screen-capture-title {
  color: #002129;
  font-size: 16px !important;
  font-weight: 800 !important;
  margin-bottom: 16px;
  margin-top: 0px;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-title {
    font-weight: 700 !important;
    margin-bottom: 8px;
    margin-top: 24px;
  }
}

.game-home-page-screen-capture-main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  max-width: 1000px;
  margin-bottom: 32px;
}

.game-home-page-screen-capture-row {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 60px;
  width: 100%;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-row {
    flex-direction: column;
    gap: 10px;
  }
}

.game-home-page-screen-capture-pair-container {
  display: flex;
  flex-direction: row;
  gap: 60px;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-pair-container {
    flex-direction: column;
    gap: 10px;
  }
}

.game-home-page-screen-capture-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-container {
    gap: 8px;
    margin-bottom: 24px;
  }
}

.game-home-page-screen-capture-title {
  color: #002129;
  text-align: center;
  font-size: 16px;
  font-weight: 800;
}
@media (max-width: 900px) {
  .game-home-page-screen-capture-title {
    font-weight: 700;
  }
}

.game-home-page-screen-capture-image-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 122px;
  height: 235px;
  background: #FFF;
  cursor: pointer;
}

.game-home-page-screen-capture-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: fill;
}

.game-home-page-video-container {
  display: flex;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  width: 100%;
  border: 1px solid #000;
  background: #FFF;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .game-home-page-video-container {
    width: 192px;
    height: 294px;
  }
}
@media (min-width: 901px) {
  .game-home-page-video-container {
    width: 321px;
    height: 220px;
  }
}

.game-home-page-video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
@media (min-width: 901px) {
  .game-home-page-video {
    object-fit: contain;
  }
}

.game-home-page-pool-preview-text {
  color: #002129;
  text-align: left;
  font-size: 20px !important;
  font-weight: 800 !important;
  margin-top: 32px !important;
  margin-bottom: 16px !important;
  text-decoration: none;
  align-self: flex-start;
}
@media (max-width: 900px) {
  .game-home-page-pool-preview-text {
    text-align: center;
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 0px;
    text-decoration: underline;
    align-self: center;
  }
}

.game-home-page-pool-preview-text-2 {
  color: #002129;
  text-align: left;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-bottom: 16px !important;
  width: 311px;
}
@media (max-width: 900px) {
  .game-home-page-pool-preview-text-2 {
    font-size: 12px !important;
  }
}

.game-home-page-media-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.game-home-page-bottom-half-container {
  display: grid;
  gap: 40px;
  align-items: start;
  justify-items: center;
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 901px) {
  .game-home-page-bottom-half-container {
    grid-template-columns: 1fr 1fr;
    width: 1000px;
  }
}
@media (max-width: 900px) {
  .game-home-page-bottom-half-container {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GameHomePage/GameHomePage.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AACJ;AAEI;EATJ;IAUQ,0BAAA;EACN;AACF;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAEI;EACI,kBAAA;AAAR;;AAIA;EACI,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAII;EATJ;IAUQ,sBAAA;IACA,MAAA;IACA,gBAAA;EADN;AACF;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAII;EACI,gBAAA;AAFR;AAIQ;EAHJ;IAIQ,kBAAA;EADV;AACF;;AAMA;EACI,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,6BAAA;AAHJ;AAMI;EAVJ;IAWQ,0BAAA;EAHN;AACF;;AAMA;EACI,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAHJ;AAMI;EARJ;IASQ,sBAAA;IACA,SAAA;IACA,gBAAA;EAHN;AACF;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAJJ;AAOI;EARJ;IASQ,2BAAA;IACA,kBAAA;IACA,gBAAA;EAJN;AACF;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAJJ;AAMI;EAPJ;IAQQ,sBAAA;IACA,SAAA;EAHN;AACF;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAHJ;AAKI;EALJ;IAMQ,sBAAA;IACA,SAAA;EAFN;AACF;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAII;EANJ;IAOQ,QAAA;IACA,mBAAA;EADN;AACF;;AAIA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EANJ;IAOQ,gBAAA;EAAN;AACF;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAIA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAII;EAbJ;IAcQ,YAAA;IACA,aAAA;EADN;AACF;AAGI;EAlBJ;IAmBQ,YAAA;IACA,aAAA;EAAN;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EALJ;IAMQ,mBAAA;EACN;AACF;;AAGA;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;AAAJ;AAGI;EAXJ;IAYQ,kBAAA;IACA,0BAAA;IACA,2BAAA;IACA,eAAA;IACA,0BAAA;IACA,kBAAA;EAAN;AACF;;AAGA;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AAGI;EATJ;IAUQ,0BAAA;EAAN;AACF;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AADJ;AAII;EATJ;IAUQ,8BAAA;IACA,aAAA;EADN;AACF;AAGI;EAdJ;IAeQ,0BAAA;EAAN;AACF","sourcesContent":[".game-home-page-join-deadline {\n    font-size: 24px !important; // Default desktop font-size\n    font-weight: 700 !important;\n    border-bottom: 2px solid #002129;\n    color: #002129;\n    background-color: #FFC60A;\n    padding: 16px 0;\n\n    // Mobile responsiveness\n    @media (max-width: 900px) { // Adjust as needed based on your mobile breakpoint\n        font-size: 16px !important; // Adjust font-size for mobile\n    }\n}\n\n.game-home-page-logo-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 160px; // 160px height + 32px margin top + 32px margin bottom\n    margin-bottom: 32px;\n    margin-top: 32px;\n\n    // Conditional margin based on dynamic logic\n    &.does-user-belong-game-over {\n        margin-bottom: 0px;\n    }\n}\n\n.game-home-page-logo {\n    height: 160px;\n    object-fit: contain;\n}\n\n.game-home-page-button-group {\n    display: flex;\n    flex-direction: row; // Default for desktop\n    align-items: center;\n    justify-content: center;\n    gap: 40px; // Default gap between buttons for desktop\n    margin-top: 32px; // Default margin-top for desktop\n\n    // Mobile styling\n    @media (max-width: 900px) {\n        flex-direction: column;\n        gap: 0; // No gap between buttons on mobile\n        margin-top: 16px; // Smaller margin on mobile\n    }\n}\n\n.game-home-page-button {\n    font-size: 14px;\n    font-weight: 700;\n    width: 182px;\n    height: 36px;\n    white-space: nowrap;\n    cursor: pointer;\n\n    // Styling specific to mobile for \"MY PICKS\" button\n    &.my-picks-button {\n        margin-bottom: 0;\n\n        @media (max-width: 900px) {\n            margin-bottom: 8px; // Add margin-bottom on mobile\n        }\n    }\n}\n\n\n.game-home-page-title {\n    color: #002129;\n    text-align: center;\n    font-size: 24px !important; // Default for desktop\n    font-weight: 700 !important;\n    text-decoration: underline !important;\n    margin-top: 32px !important;\n    margin-bottom: 8px !important;\n\n    // Mobile styling\n    @media (max-width: 900px) {\n        font-size: 16px !important; // Adjust font-size for mobile\n    }\n}\n\n.game-home-page-subtitle {\n    color: #002129;\n    text-align: center;\n    font-size: 16px !important; // Default for desktop\n    font-weight: 600 !important;\n    margin-bottom: 16px !important;\n}\n\n.game-home-page-action-buttons {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 48px; // Space between buttons\n    margin-top: 32px;\n\n    // Mobile adjustments\n    @media (max-width: 900px) {\n        flex-direction: column;\n        gap: 16px; // Smaller gap between buttons\n        margin-top: 16px; // Smaller margin-top\n    }\n}\n\n\n.game-home-page-screen-capture-container {\n    text-align: center;\n}\n\n.game-home-page-screen-capture-title {\n    color: #002129;\n    font-size: 16px !important; // Default for desktop\n    font-weight: 800 !important; // Default for desktop\n    margin-bottom: 16px;\n    margin-top: 0px;\n\n    // Mobile adjustments\n    @media (max-width: 900px) {\n        font-weight: 700 !important; // Adjust font-weight for mobile\n        margin-bottom: 8px;\n        margin-top: 24px;\n    }\n}\n\n.game-home-page-screen-capture-main-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 32px;\n    max-width: 1000px;\n    margin-bottom: 32px;\n}\n\n.game-home-page-screen-capture-row {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    gap: 60px;\n    width: 100%;\n\n    @media (max-width: 900px) {\n        flex-direction: column;\n        gap: 10px;\n    }\n}\n\n.game-home-page-screen-capture-pair-container {\n    display: flex;\n    flex-direction: row;\n    gap: 60px;\n\n    @media (max-width: 900px) {\n        flex-direction: column;\n        gap: 10px;\n    }\n}\n\n.game-home-page-screen-capture-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n\n    @media (max-width: 900px) {\n        gap: 8px;\n        margin-bottom: 24px;\n    }\n}\n\n.game-home-page-screen-capture-title {\n    color: #002129;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 800;\n\n    @media (max-width: 900px) {\n        font-weight: 700;\n    }\n}\n\n.game-home-page-screen-capture-image-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 122px;\n    height: 235px;\n    background: #FFF;\n    cursor: pointer;\n}\n\n.game-home-page-screen-capture-image {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: fill;\n}\n\n\n.game-home-page-video-container {\n    display: flex;\n    padding: 16px 0;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    align-self: stretch;\n    width: 100%; // Default width; will be controlled by media queries\n    border: 1px solid #000;\n    background: #FFF;\n    margin: 0 auto;\n\n    // Responsive styles\n    @media (max-width: 900px) { // Example for mobile\n        width: 192px;\n        height: 294px;\n    }\n\n    @media (min-width: 901px) { // Example for desktop\n        width: 321px;\n        height: 220px;\n    }\n}\n\n.game-home-page-video {\n    width: 100%;\n    height: 100%; // Ensures it fills the height of the parent Box\n    object-fit: fill; // Adjust based on your requirements\n\n    @media (min-width: 901px) { // Ensure it contains in desktop view\n        object-fit: contain; // Change object fit for larger screens\n    }\n}\n\n\n.game-home-page-pool-preview-text {\n    color: #002129;\n    text-align: left; // Default for desktop\n    font-size: 20px !important; // Default for desktop\n    font-weight: 800 !important; // Default for desktop\n    margin-top: 32px !important; // Default for desktop\n    margin-bottom: 16px !important; // Default for desktop\n    text-decoration: none; // Default for desktop\n    align-self: flex-start; // Default for desktop\n\n    // Responsive styles for mobile\n    @media (max-width: 900px) {\n        text-align: center;\n        font-size: 16px !important;\n        font-weight: 700 !important;\n        margin-top: 0px;\n        text-decoration: underline;\n        align-self: center;\n    }\n}\n\n.game-home-page-pool-preview-text-2 {\n    color: #002129;\n    text-align: left;\n    font-size: 14px !important; // Default for desktop\n    font-weight: 500 !important; // Default for desktop\n    margin-bottom: 16px !important; // Default for desktop\n    width: 311px;\n\n    // Responsive styles for mobile\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n    }\n}\n\n\n.game-home-page-media-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.game-home-page-bottom-half-container {\n    display: grid;\n    gap: 40px; // Gap between grid items\n    align-items: start;\n    justify-items: center;\n    width: 100%; // Default width for mobile\n    margin: 0 auto; // Center the grid container horizontally\n\n    // Responsive styles\n    @media (min-width: 901px) { // Adjust for desktop view\n        grid-template-columns: 1fr 1fr; // Two columns for desktop\n        width: 1000px; // Specific width for desktop\n    }\n\n    @media (max-width: 900px) { // Adjust for mobile view\n        grid-template-columns: 1fr; // One column for mobile\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
